<template>
    <base-tool
        :tool-name="tool.name"
        :tool-description="tool.description"
        @back="goBack"
    >
        <div 
            class="form-group"
            data-testid="voicemail-tool-form-group"
        >
            <label data-testid="voicemail-tool-label">Custom Voicemail Message (Optional)</label>
            <textarea
                v-model="customMessage"
                data-testid="voicemail-tool-message-textarea"
                class="form-control"
                rows="3"
                placeholder="e.g., 'Thanks for calling! Please leave your message after the beep and we'll get back to you soon.'"
                @input="handleMessageChange"
            ></textarea>
            <small 
                class="form-text text-muted"
                data-testid="voicemail-tool-help-text"
            >
                If left empty, the default message "Please leave your message after the beep." will be used.
            </small>
        </div>


        <div class="mt-3">
            <el-button 
                data-testid="voicemail-tool-add-button"
                type="primary" 
                @click="addVoicemailTool"
                :disabled="!previewText"
            >
                Add Leave Voicemail
            </el-button>
        </div>
    </base-tool>
</template>

<script>
import BaseTool from './base-tool.vue'
import * as AloAi from '../../../../constants/aloai'
import ToolMixin from './tool-mixin'

export default {
    name: 'VoicemailTool',

    mixins: [ToolMixin],

    components: {
        BaseTool,
    },

    props: {
        tool: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            customMessage: ''
        }
    },

    computed: {
        previewText() {
            if (this.customMessage.trim()) {
                return `{Leave voicemail: ${this.customMessage.trim()}}`
            }
            return '{Leave voicemail: Please leave your message after the beep.}'
        }
    },

    methods: {
        handleMessageChange() {
            // Update preview text when message changes
        },

        addVoicemailTool() {
            this.$emit('voicemail-selected', { text: this.previewText })
        }
    }
}
</script>

<style scoped>

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #495057;
}

.form-control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-text {
    font-size: 12px;
    margin-top: 5px;
}

.preview-section {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #dee2e6;
}

.preview-section label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #495057;
}

.preview-content {
    background: #e9ecef;
    padding: 10px;
    border-radius: 4px;
    font-family: 'Monaco', 'Consolas', monospace;
    font-size: 13px;
    color: #495057;
    min-height: 40px;
    border: 1px solid #ced4da;
}
</style>
